import React from 'react';
import { CreditCard } from 'lucide-react';
import LegalPageLayout, { LegalSection } from './LegalPageLayout';

const PaymentMethodsPage = ({ totalItems, totalFavorites, setCurrentPage }) => {
  return (
    <LegalPageLayout
      title="طرق الدفع"
      icon={<CreditCard className="h-8 w-8" />}
      lastUpdated="17 يوليو 2026"
      totalItems={totalItems}
      totalFavorites={totalFavorites}
      setCurrentPage={setCurrentPage}
    >
      <LegalSection title="مقدمة">
        <p>
          نوفر في صيدلية الريان أكثر من وسيلة دفع آمنة وموثوقة لتسهيل عملية الشراء وضمان راحتك
          عند إتمام طلبك.
        </p>
      </LegalSection>

      <LegalSection title="الدفع عند الاستلام">
        <p>
          يمكنك دفع قيمة طلبك نقدًا مباشرة عند استلامه من مندوب التوصيل، وهي الطريقة الأكثر
          شيوعًا لدى عملائنا.
        </p>
      </LegalSection>

      <LegalSection title="الدفع الإلكتروني">
        <ul className="list-inside list-disc space-y-2">
          <li>البطاقات الائتمانية ومطاريف الدفع (Visa وMastercard).</li>
          <li>محافظ الدفع الإلكترونية.</li>
          <li>التحويل البنكي المباشر لبعض الطلبات الكبيرة.</li>
        </ul>
      </LegalSection>

      <LegalSection title="أمان عمليات الدفع">
        <p>
          جميع عمليات الدفع الإلكتروني تتم عبر بوابات دفع معتمدة ومشفّرة، ولا نقوم بتخزين
          بيانات بطاقتك البنكية على خوادمنا في أي وقت.
        </p>
      </LegalSection>

      <LegalSection title="الفواتير">
        <p>
          يتم إرفاق فاتورة إلكترونية تفصيلية بكل طلب توضح المنتجات والأسعار وأي خصومات مطبّقة،
          ويمكنك أيضًا الاطلاع على سجل طلباتك وفواتيرها من خلال حسابك على الموقع.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default PaymentMethodsPage;
